<template>
  <div class="admin-orders">
    <header-title title="Historial de Pagos"></header-title>

    <div class="page-title">
      <v-container class="pl-0 pr-0">
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4" lg="2">
            <date-picker-range @updateDates="onChangeDate"></date-picker-range>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field
              outlined
              dense
              label="Buscar"
              v-model="search"
              class="select-box"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              @change="onChangePaymentMethod"
              :items="paymentMethodDropdown"
              item-text="label"
              item-value="value"
              label="Tipo de pago"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              v-model="selectedQR"
              :items="activesQR"
              :label="selectLabelQR"
              @change="onChangeTable"
              :item-text="qr => tableQRLabel(qr.table)"
              item-value="table"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              @change="onChangeInvoiceRequest"
              :items="invoiceRequestDropdown"
              item-text="label"
              item-value="value"
              label="Factura/Ticket"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="12" lg="2">
            <v-btn
              :style="`border: 3px solid ${colorsGeneralPrimary}`"
              :color="colorsGeneralPrimary"
              outlined
              text
              class="admin-excel-download-btn mx-3"
              @click="$refs.paymentHistoryRef.exportToExcel(excelName)"
            >
              Exportar a Excel
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col cols="12" sm="6" md="12" lg="2">
            <v-select
              v-model="selectedPrinterForTicket"
              :items="printers"
              item-text="name"
              item-value="url"
              :label="`Impresora Ticket`"
              dense
              outlined
              return-object
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="7"> </v-col>
        </v-row>
      </v-container>
    </div>

    <PaymentsHistory
      ref="paymentHistoryRef"
      :payments="payments"
      :ticketPrinter="selectedPrinterForTicket"
      :search="search"
    ></PaymentsHistory>
  </div>
</template>

<script>
import moment from "moment";
import PaymentsHistory from "../../../components/admin/payment/PaymentsHistory";
import { printersCollection } from "@/collections/printers";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import DatePickerRange from "@/components/common/DatePickerRange";
import { qrCollection } from "@/collections/qrs";
import { typeOrdersCollection } from "@/collections/typeOrders";

const INITIAL_DATE_START = moment()
  .startOf("day")
  .toDate();
const INITIAL_DATE_END = moment()
  .endOf("day")
  .toDate();

export default {
  name: "PaymentHistory",
  components: {
    PaymentsHistory,
    HeaderTitle,
    DatePickerRange
  },
  data() {
    return {
      search: "",
      paymentMethodDropdown: [
        {
          label: "Todos",
          value: "all"
        },
        {
          label: "Efectivo",
          value: "cash"
        },
        {
          label: "Tarjeta de crédito",
          value: "credit_card"
        },
        {
          label: "Datáfono",
          value: "datafono"
        },
        {
          label: "Google Pay",
          value: "googlepay"
        },
        {
          label: "Apple Pay",
          value: "applepay"
        },
        {
          label: "Bizum",
          value: "bizum"
        }
      ],
      invoiceRequestDropdown: [
        {
          label: "Todos",
          value: "all"
        },
        {
          label: "Factura",
          value: true
        },
        {
          label: "Ticket",
          value: false
        }
      ],
      locale: {
        id: "es",
        firstDayOfWeek: 2,
        masks: {
          input: "YYYY-MM-DD 00:00:00"
        }
      },
      popover: {
        visibility: "click"
      },
      rangeOfDates: {
        start: INITIAL_DATE_START,
        end: INITIAL_DATE_END
      },
      paymentMethodSelected: "all",
      invoiceRequestSelected: "all",
      selectedQR: { id: "todas", table: "todas" },
      selectLabelQR: "Selecciona mesa",
      qrCollection: [],
      typeOrders: [],
      printers: [],
      selectedPrinterForTicket: {}
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table"),
      printers: printersCollection.where("active", "==", true),
      typeOrders: typeOrdersCollection
    };
  },
  computed: {
    activesQR() {
      let qr = [...this.qrCollection];
      qr = qr.sort((a, b) => {
        return a.table.localeCompare(b.table, undefined, {
          numeric: true,
          sensitivity: "base"
        });
      });
      return [{ id: "todas", table: "todas" }, ...qr];
    },
    groupPrinters() {
      let printers = [...this.typeOrders].filter(
        x => x.id === "NrvVDU23IcES9E9rBI39"
      );
      printers.map(x => {
        let printerUrl = localStorage.getItem(`printer_${x.id}`);
        return (x.printerUrl = printerUrl);
      });
      return printers;
    },
    payments() {
      let paymentsHistory = [...this.$store.state.paymentHistory];

      if (this.paymentMethodSelected !== "all") {
        paymentsHistory = paymentsHistory.filter(
          item => item.payment_method === this.paymentMethodSelected
        );
      }

      if (this.invoiceRequestSelected !== "all") {
        paymentsHistory = paymentsHistory.filter(
          item => item.invoiceRequest === this.invoiceRequestSelected
        );
      }

      if (
        this.selectedQR !== "todas" &&
        this.selectedQR &&
        this.selectedQR.table !== "todas"
      ) {
        paymentsHistory = paymentsHistory.filter(
          item => item.tableQR === this.selectedQR
        );
      }

      return paymentsHistory;
    },
    excelName() {
      return `historial_pagos(${this.dayFormat2(
        this.rangeOfDates.start
      )}-${this.dayFormat2(this.rangeOfDates.start)}).xls`;
    },
    total() {
      return this.payments.reduce((a, b) => {
        return Number(a) + Number(b.amount_paid_by_user);
      }, 0);
    }
  },
  methods: {
    onChangeDate(dates) {
      let date1;
      let date2;

      if (dates.length === 1 || dates[0] === dates[1]) {
        date1 = moment(dates[0])
          .startOf("day")
          .toDate();
        date2 = moment(dates[0])
          .endOf("day")
          .toDate();
      }

      if (dates.length === 2) {
        date1 = moment(dates[0])
          .startOf("day")
          .toDate();
        date2 = moment(dates[1])
          .endOf("day")
          .toDate();
      }

      let _rangeOfDates = {
        start: date1,
        end: date2
      };

      this.rangeOfDates = _rangeOfDates;

      this.$store.dispatch("paymentsHistoryByRangeOfDate", _rangeOfDates);
    },
    onChangePaymentMethod(value) {
      this.paymentMethodSelected = value;
    },
    onChangeInvoiceRequest(value) {
      this.invoiceRequestSelected = value;
    },
    onChangeTable(value) {
      this.selectedQR = value;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-product-type {
  font-size: 16px;
  padding: 6px;
  border-radius: 3px;
  background: #fff;
  margin-left: 10px;
  border: 1px solid #cbd5e0;
}

.filters {
  width: 70%;
  margin: 0 auto;
}

@media (max-width: 991px) {
  .filters {
    width: 100%;
  }
}

::v-deep {
  .vc-popover-content-wrapper {
    @media screen and (max-width: 471px) {
      width: 80%;
      overflow: hidden;
    }
  }

  .vc-popover-content {
    @media screen and (max-width: 471px) {
      width: 95%;
      overflow: auto;
    }
  }

  .v-icon.v-icon {
    @media screen and (max-width: 823px) {
      right: -9px;
    }
  }
}
</style>
